import { useTranslation } from 'react-i18next'
import { Badge } from '@/components/ui/badge'
import { CreditCard, Banknote, Clock, CheckCircle2, RotateCcw } from 'lucide-react'
import { cn } from '@/lib/utils'
import { getPaymentStatusColor, getPaymentStatusLabel } from '../utils'

interface PaymentStatusBadgeProps {
  paymentStatus: string
  refundStatus?: string | null
  className?: string
  showIcon?: boolean
}

import { getRefundStyle } from '@/config/design-tokens'

export function PaymentStatusBadge({ paymentStatus, refundStatus, className, showIcon = true }: PaymentStatusBadgeProps) {
  const { t } = useTranslation('orders')
  const colors = getPaymentStatusColor(paymentStatus)
  const label = getPaymentStatusLabel(paymentStatus)

  // Determine icon
  let Icon = CreditCard
  if (paymentStatus === 'cash') {
    Icon = Banknote
  } else if (paymentStatus === 'pending') {
    Icon = Clock
  } else if (paymentStatus.includes('success')) {
    Icon = CheckCircle2
  }

  return (
    <div className="flex items-center gap-1.5">
      <Badge
        variant="outline"
        className={cn(
          colors.bg,
          colors.text,
          'border-transparent font-medium',
          className
        )}
      >
        {showIcon && <Icon className="w-3 h-3 me-1" />}
        {label}
      </Badge>
      {refundStatus && (
        <Badge
          variant="outline"
          className={cn(
            getRefundStyle(refundStatus).bg,
            getRefundStyle(refundStatus).text,
            'border-transparent font-medium',
            className
          )}
        >
          {showIcon && <RotateCcw className="w-3 h-3 me-1" />}
          {t(`refund.status.${refundStatus}`, refundStatus)}
        </Badge>
      )}
    </div>
  )
}
